export default __webpack_public_path__ + "static/media/feature-item-feature-rich.e10bb4bb.svg";